import i18n from 'i18next';

export const API = "api";

export const SYNC_IMAP = "SyncImap";

export const API_V1 = "v1";

export const API_V2 = "v2";

export const PROVIDER = "IMAP";

export const STATUS_CANCELLED = "cancelled";

export const FONT_FAMILY = {
  default: 'Segoe UI',
  width: 'auto',
  items: [
    {
      text: 'Segoe UI',
      value: 'Segoe UI',
      cssClass: 'e-segoe-ui',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Arial',
      value: 'Arial,sans-serif',
      cssClass: 'e-arial',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Courier New',
      value: 'Courier New,Courier,monospace',
      cssClass: 'e-courier-new',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Georgia',
      value: 'Georgia,serif',
      cssClass: 'e-Georgia',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Helvetica',
      value: 'Helvetica',
      cssClass: 'e-helvetica',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Gadugi',
      value: 'Gadugi',
      cssClass: 'e-gadugi',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Impact',
      value: 'Impact,Charcoal,sans-serif',
      cssClass: 'e-impact',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Calibri Light',
      value: 'CalibriLight',
      cssClass: 'e-calibri-light',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Tahoma',
      value: 'Tahoma,Geneva,sans-serif',
      cssClass: 'e-tahoma',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Times New Roman',
      value: 'Times New Roman,Times,serif',
      cssClass: 'e-times-new-roman',
      command: 'FontName',
      subCommand: 'FontName'
    },
    {
      text: 'Verdana',
      value: 'Verdana,Geneva,sans-serif',
      cssClass: 'e-verdana',
      command: 'FontName',
      subCommand: 'FontName'
    }
  ]
};

export const SLOT_DURATION_ES = [
  {
    text: '1 hora',
    value: 60,
    id: '1'
  },
  {
    text: '2 horas',
    value: 120,
    id: '2'
  },
  {
    text: '3 horas',
    value: 180,
    id: '3'
  },
  {
    text: '4 horas',
    value: 240,
    id: '4'
  },
  {
    text: '5 horas',
    value: 300,
    id: '5'
  },
  {
    text: '6 horas',
    value: 360,
    id: '6'
  },
  {
    text: '7 horas',
    value: 420,
    id: '7'
  },
  {
    text: '8 horas',
    value: 480,
    id: '8'
  },
  {
    text: '9 horas',
    value: 540,
    id: '9'
  },
  {
    text: '10 horas',
    value: 600,
    id: '10'
  },
  {
    text: '11 horas',
    value: 660,
    id: '11'
  },
  {
    text: '12 horas',
    value: 720,
    id: '12'
  }
];

export const SLOT_DURATION_EN = [
  {
    text: '1 hours',
    value: 60,
    id: '1'
  },
  {
    text: '2 hours',
    value: 120,
    id: '2'
  },
  {
    text: '3 hours',
    value: 180,
    id: '3'
  },
  {
    text: '4 hours',
    value: 240,
    id: '4'
  },
  {
    text: '5 hours',
    value: 300,
    id: '5'
  },
  {
    text: '6 hours',
    value: 360,
    id: '6'
  },
  {
    text: '7 hours',
    value: 420,
    id: '7'
  },
  {
    text: '8 hours',
    value: 480,
    id: '8'
  },
  {
    text: '9 hours',
    value: 540,
    id: '9'
  },
  {
    text: '10 hours',
    value: 600,
    id: '10'
  },
  {
    text: '11 hours',
    value: 660,
    id: '11'
  },
  {
    text: '12 hours',
    value: 720,
    id: '12'
  }
];

export const SLOT_INTERVAL = [
  {
    text: '1',
    value: 1,
    id: '1'
  },
  {
    text: '2',
    value: 2,
    id: '2'
  },
  {
    text: '3',
    value: 3,
    id: '3'
  },
  {
    text: '4',
    value: 4,
    id: '4'
  },
  {
    text: '5',
    value: 5,
    id: '5'
  },
  {
    text: '6',
    value: 6,
    id: '6'
  },
  {
    text: '7',
    value: 7,
    id: '7'
  },
  {
    text: '8',
    value: 8,
    id: '8'
  },
  {
    text: '9',
    value: 9,
    id: '9'
  },
  {
    text: '10',
    value: 10,
    id: '10'
  }
];

export const DAY_WEEK = {
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday'
};

export const RoundedPaletteColors = {
  custom1: [
    '#750c20',
    '#0e2b21',
    '#a4864a',
    '#30197e',
    '#914150',
    '#435850',
    '#b69e70',
    '5c4b98',
    '#ab1279',
    '#ced038',
    '#d4bb8a',
    '13439b',
    '#bc4594',
    '#d8da62',
    '#ddc9a2',
    '466ab0',
    '#e6879e',
    '#68747c',
    '#d6b43c',
    '40b6b5',
    '#eb9fb3',
    '879096',
    '#dec365',
    '68c5c3',
    '#0078d4',
    '#498205',
    '#da3b01',
    '#69797e',
    '#18a7b5',
    '#e3008c',
    '#b5651d',
    '#c50f1f',
    '#4C5EA0',
    '#59AC85',
    '#FFB759',
    '#C9CAC9',
    '#C2F0E8',
    '#F5D359',
    '#E5D6B8',
    '#E16668'
  ]
};

export const SCHEDULE_FIELDS = {
  subject: {
    name: 'Subject',
    validation: { required: true }
  },
  startTime: {
    name: 'StartTime',
    validation: { required: true },
    title: 'Empezar'
  },
  endTime: {
    name: 'EndTime',
    validation: { required: true },
    title: 'Finalizar',
    placeholder: 'Selecciona una fecha y hora'
  },
  startTimezone: {
    title: 'Zona horaria inicio'
  },
  endTimezone: {
    title: 'Zona horaria fin'
  },
  description: {
    validation: { maxLength: 3000 },
    name: 'Description'
  }
};

export const getToast = event => ({
  toast: [
    {
      content: i18n.t('schedule.toast-processing'),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('schedule.toast-process-complete'),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('schedule.toast-process-error'),
      cssClass: 'e-toast-danger',
      icon: 'lf-icon lf-icon-close-round'
    },
    {
      content: i18n
        .t('schedule.toast-delete-calendar-complete')
        .replace('{}', event?.name),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('schedule.toast-create-calendar-complete'),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('schedule.toast-edit-calendar-complete'),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('calendar.slot_save_success'),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n
        .t('schedule.toast-create-event-complete')
        .replace('{}', event?.Subject),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('schedule.toast-create-event-error'),
      cssClass: 'e-toast-danger',
      icon: 'lf-icon lf-icon-close-round'
    },
    {
      content: i18n
        .t('schedule.toast-edit-event-complete')
        .replace('{}', event?.Subject),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('schedule.toast-edit-event-error'),
      cssClass: 'e-toast-danger',
      icon: 'lf-icon lf-icon-close-round'
    },
    {
      content: i18n
        .t('schedule.toast-delete-event-complete')
        .replace('{}', event?.Subject),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n
        .t('schedule.toast-delete-event-error')
        .replace('{}', event?.Subject),
      cssClass: 'e-toast-danger',
      icon: 'lf-icon lf-icon-close-round'
    },
    {
      content: i18n.t('schedule.toast-process-filter-type-complete'),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n.t('schedule.toast-updated-color-complete'),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n
        .t('schedule.toast-delete-event-recurrence-complete')
        .replace('{}', event?.Subject),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n
        .t('schedule.toast-edit-event-recurrence-complete')
        .replace('{}', event?.Subject),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    },
    {
      content: i18n
        .t('schedule.toast-create-event-recurrence-complete')
        .replace('{}', event?.Subject),
      cssClass: 'e-toast-success',
      icon: 'lf-icon lf-icon-check-round'
    }
  ]
});

export const NOT_FOUND = '404';

export const BUTTONS = {
  left: 0,
  right: 2
};

export const SOCIAL_NETWORK = {
  linkedin: window.SOCIAL_LINKEDIN_URL,
  youtube: window.SOCIAL_YOUTUBE_URL,
  facebook: window.SOCIAL_FACEBOOK_URL,
  twitter: window.SOCIAL_TWITTER_URL,
  instagram: window.SOCIAL_INSTAGRAM_URL
};
export const ALL_RESERVED = {
  terms: window.LEGAL_WARNING_URL,
  privacy: window.PRIVACY_POLICY_URL,
  cookies: window.COOKIES_POLICY_URL
};

export const fileExtensionTypes = {
  word: 'docx',
  pdf: 'pdf',
  jpg: 'jpg',
  png: 'png',
  txt: 'txt',
  excel: 'xlsx',
  ppt: 'ppt'
};

export const FORBIDDEN_EXTENSIONS = [
  'ade',
  'adp',
  'apk',
  'appx',
  'appxbundle',
  'bat',
  'cab',
  'chm',
  'cmd',
  'com',
  'cpl',
  'dll',
  'dmg',
  'exe',
  'hta',
  'ins',
  'isp',
  'iso',
  'jar',
  'js',
  'jse',
  'lib',
  'lnk',
  'mde',
  'msc',
  'msi',
  'msix',
  'msixbundle',
  'msp',
  'mst',
  'nsh',
  'pif',
  'ps1',
  'scr',
  'sct',
  'shb',
  'sys',
  'vb',
  'vbe',
  'vbs',
  'vxd',
  'wsc',
  'wsf',
  'wsh',
];

export const MIMETYPE = {
  png: 'IMAGE/png',
  jpeg: 'IMAGE/jpeg',
  pdf: 'APPLICATION/pdf',
  text: 'TEXT/plain',
  doc: 'APPLICATION/vnd.openxmlformats-officedocument.wordprocessingml.document'
};

export const TYPE_ROLE_CALENDAR = {
  owner: 'owner',
  read_write: 'read-write',
  read: 'read'
};

export const ITEM_EVENT_TEMPLATE = '<div class="type-item-form"><div class="type-item-form-dot-container" style="border: 1px solid ${backgroundColor}"><span class="type-item-form-dot" style="background-color:${backgroundColor}"></span></div><span class="type-item-form-text">${text}</span></div>';
